import React, { createContext, useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap'
import { StyledToast } from 'components/Share/Toast.styled'
import { useLocation } from 'react-router-dom'

export interface IToastContext {
  setToastData: (isShow: boolean, message: string, type: string, autohide?: boolean) => void
  setShowToast: (isShow: boolean) => void
}

export const ToastContext = createContext<IToastContext>({} as IToastContext)

export const ToastContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [showToast, setShowToast] = useState<boolean>(false)
  const [toastMessage, setToastMessage] = useState<string>('')
  const [toastType, setToastType] = useState<string>('')
  const [autoHide, setAutoHide] = useState<boolean>(true)

  const location = useLocation()

  useEffect(() => {
    setShowToast(false)
  }, [location.pathname])

  const setToastData = (isShow: boolean, message: string, type: string, autoHide: boolean = true) => {
    setShowToast(isShow)
    setToastMessage(message)
    setToastType(type)
    setAutoHide(autoHide)
  }

  return (
    <ToastContext.Provider
      value={{
        setToastData,
        setShowToast
      }}
    >
      <StyledToast
        onClose={() => setShowToast(false)}
        type={toastType}
        show={showToast}
        className="toast-contain"
        delay={8000}
        autohide={autoHide}
      >
        <Toast.Body className="toast-body">{toastMessage}</Toast.Body>
        <button onClick={() => setShowToast(false)}>x</button>
      </StyledToast>
      {children}
    </ToastContext.Provider>
  )
}
